import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {getReservedForFields as getReservedForFieldsAPI} from '../../../services/reservations'
import fixture from '../../../fixtures/reservedForFields.json'

export async function getReservedForFields(dispatch, group_id) {
  try {
    dispatch({type: PENDING})
    let response = await getReservedForFieldsAPI(group_id)
    //let response = fixture
    dispatch({type: SUCCESS, payload: response})
    return response
  } catch (e) {
    console.log(`Get Reservation Configuration Failed: ${group_id}`)
    dispatch({type: FAILURE, payload: e})
    return Promise.reject(e)
  }
}
